import { render } from "./QuoteRequest.vue?vue&type=template&id=676126f2&scoped=true"
import script from "./QuoteRequest.vue?vue&type=script&lang=js"
export * from "./QuoteRequest.vue?vue&type=script&lang=js"

import "./QuoteRequest.vue?vue&type=style&index=0&id=676126f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-676126f2"]])

export default __exports__